export default __webpack_public_path__ + "static/media/recording_gif.4e371e43.gif";